<template>
  <div class="xcard">
    <!-- <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    > -->
    <h3 class="text-center">Menu Datos para Facturas Electronicas</h3>
    <p class="text-center text-primary" style="margin-bottom:0">
      <small class="center-block">
        <span class="glyphicon glyphicon-exclamation-sign"></span> Registrar datos para emitir facturas electronicas.
      </small>
    </p>

    <v-row>
      <v-col sm="3" lg="2">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/clientes')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/working-office-lady-boss-worker-260nw-760356136.jpg" />
            <p class="text-h5 text--primary">
              <small>Clientes</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/documentos')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/pago-con-tarjeta.webp" />
            <p class="text-h5 text--primary" style="white-space: nowrap;">
              <small>Tipo documentos</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/fpagos')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/cartoon-people-cashing-money-atm-set_81522-4666.webp" />
            <p class="text-h5 text--primary">
              <small>Formas de pago</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/umedidas')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/unidades-de-medida.jpg?height=225&width=320" />
            <p class="text-h5 text--primary">
              <small>Unidades Medida</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/conceptospago')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/seguridad-de-datos.jpg" />
            <p class="text-h5 text--primary">
              <small>Conceptos</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/xsucursales')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/internet-plano.webp" />
            <p class="text-h5 text--primary">
              <small>Sucursales</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/nits')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/imagen_principa.webp" />
            <p class="text-h5 text--primary">
              <small>Nits</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/eventossig')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/people-meeting-online-via-video-conference-.jpg" />
            <p class="text-h5 text--primary">
              <small>Contingencia</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/emisionpaquetes')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img
              height="150"
              src="img/menu_facturacion/pngtree-cartoon-home-delivery-service-elements-png-image_2382262.jpg"
            />
            <p class="text-h5 text--primary">
              Emision por paq.
            </p>
          </v-card-text>
        </v-card>
      </v-col> -->

      <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/emisionmasivo')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/pngtree-hand-drawn-cartoon-delivery-service.jpg" />
            <p class="text-h5 text--primary">
              <small>Ev. Masivos</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/cafc')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img
              height="150"
              src="img/menu_facturacion/pngtree-cartoon-home-delivery-service-elements-png-image_2382262.jpg"
            />
            <p class="text-h5 text--primary">
              <small>Cafc.</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/facturaspendientes')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img
              height="150"
              src="https://us.123rf.com/450wm/ruangwit/ruangwit1504/ruangwit150400005/39056064-empresario-de-trabajo-bastante-renunciar-encofrado-trabajador-despedido-personaje-de-dibujos-animado.jpg?ver=6"
            />
            <p class="text-h5 text--primary">
              <small>Fact. pendientes.</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col> -->

      <v-col sm="3" lg="2">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/sincroonline')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/ilustracionarreglando.webp" />
            <p class="text-h5 text--primary">
              <small>Estado Sys</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="3" lg="2" v-if="$store.state.CARGO.id == 1">
        <v-card class="mx-auto" max-width="344" @click="$router.push('/sincronizar')">
          <v-card-text>
            <div>Menu registro de:</div>
            <v-img height="150" src="img/menu_facturacion/sincro.webp" />
            <p class="text-h5 text--primary">
              <small>Sincronizar.</small>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    components: {},
    watch: {},
  };
</script>
